import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import NavigationBar from 'components/NavigationBar/NavigationBar.js';
// @mui material components
import CssBaseline from '@mui/material/CssBaseline';
import Settings from '@mui/icons-material/Settings';
import Box from '@mui/material/Box';

//  React components
import MDBox from 'components/MDBox';
//  React contexts
import { setOpenConfigurator, useMaterialUIController } from 'context';
import Configurator from 'examples/Configurator';
import Layout from 'layouts/LayoutContainers/Layout';
import Missing from 'layouts/missing';
//  React example components
import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// react-router components
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { setSelectedCustomer, setSelectedDistributor } from './stores/sensor/sensorStore';
//  React routes
import routes from 'routes';
//  React themes
// RTL plugins
import rtlPlugin from 'stylis-plugin-rtl';
import SignIn from './layouts/authentication/sign-in';
// check token validation and refresh
import useTokenManager from './hooks/useTokenManager';
export default function App() {
  const dispatchRedux = useDispatch();

  // const dispatch = useDispatch();
  const backdropOpen = useSelector(state => state.backdrop.open);
  const currentUser = useSelector(state => state.sensors.currentUser);
  const { selectedFilterObject } = useSelector(state => state.persistence);
  const [controller, dispatch] = useMaterialUIController();
  const { direction, openConfigurator } = controller;
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();
  const { distributor, customer } = selectedFilterObject;
  const [isAuthInitialized, setIsAuthInitialized] = useState(false);
  const token = useSelector(state => state.sensors.token);

  const { initializeAuth, isTokenExpired } = useTokenManager();

  const publicRoutes = [
    '/authentication/sign-in',
    '/reset-password',
    '/authentication/sign-up',
    '/test',
  ];
  const isPublicRoute = publicRoutes.some(route => pathname.startsWith(route));

  useEffect(() => {
    initializeAuth()
      .then(() => setIsAuthInitialized(true))
      .catch(() => setIsAuthInitialized(true));

    if (distributor === '' && currentUser.role === 's') {
      dispatchRedux(setSelectedDistributor('all'));
    }
    if ((customer === '' || customer === 'all') && currentUser.role === 'c') {
      dispatchRedux(setSelectedCustomer(currentUser.user_id));
    }
  }, []);

  useEffect(() => {
    setOpenConfigurator(dispatch, false);
  }, [pathname]);

  // Cache for the rtl
  useMemo(() => {
    const cacheRtl = createCache({
      key: 'rtl',
      stylisPlugins: [rtlPlugin],
    });

    setRtlCache(cacheRtl);
  }, []);

  // Change the openConfigurator state
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute('dir', direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = allRoutes =>
    allRoutes.map(route => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }
      return null;
    });

  const configsButton = (
    <MDBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="2.8rem"
      height="2.8rem"
      bgColor="white"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      top="1.1rem"
      zIndex={30001}
      color="dark"
      sx={{ cursor: 'pointer', boxShadow: '0px 0px 14px 5px rgba(0,0,0,0.2)' }}
      onClick={handleConfiguratorOpen}>
      <Settings fontSize="small" color="inherit">
        settings
      </Settings>
    </MDBox>
  );

  if (!isAuthInitialized) {
    return (
      <Backdrop open={true}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (!token && !isPublicRoute) {
    return <SignIn />;
  }

  return (
    <>
      <CacheProvider value={rtlCache}>
        <CssBaseline />
        {/* <TopBar className="logo"></TopBar> */}
        {pathname !== '/authentication/sign-in' && pathname !== '/test' && (
          <>
            <Configurator />
            {configsButton}
          </>
        )}
        {/* <div style={{border: "2px solid green", display: 'flex', justifyContent: 'center'}}>
          <div style={{border: "2px solid black", }}></div>
        </div> */}
        {!isPublicRoute && <NavigationBar />}
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path="/" element={<Navigate to="/home" />} />
            {getRoutes(routes)}
            <Route path="*" element={<Missing />} />
          </Route>
        </Routes>
      </CacheProvider>
      <Backdrop open={backdropOpen}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
